import Modal from 'react-modal';
import './styles.scss';
import { deleteUnitRoleService } from '../../../../../services/scheduling';
import { isResponseOk } from '../../../../../utility/isResponseOk';

const CancelPostedShiftsModal = ({ closeModal, handleConfirm }) => {
  const handleClose = () => {
    closeModal();
  };

  return (
    <Modal
      className="modal-alert cancel-posted-shifts-modal"
      isOpen
      onRequestClose={handleClose}
      contentLabel="Cancel posted shifts modal"
      ariaHideApp={false}
    >
      <h2 className="modal-header">
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="5" y="5" width="38" height="38" rx="19" fill="#FEE4E2" />
          <rect x="5" y="5" width="38" height="38" rx="19" stroke="#FFF2F1" strokeWidth="10" />
          <g clipPath="url(#clip0_13465_79709)">
            <path
              d="M23.9999 21.3359V24.0026M23.9999 26.6693H24.0066M30.6666 24.0026C30.6666 27.6845 27.6818 30.6693 23.9999 30.6693C20.318 30.6693 17.3333 27.6845 17.3333 24.0026C17.3333 20.3207 20.318 17.3359 23.9999 17.3359C27.6818 17.3359 30.6666 20.3207 30.6666 24.0026Z"
              stroke="#B42318"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_13465_79709">
              <rect width="16" height="16" fill="white" transform="translate(16 16)" />
            </clipPath>
          </defs>
        </svg>

        <button className="btn btn-icon" onClick={handleClose}>
          <i className="icon-icon-x"></i>
        </button>
      </h2>

      <div>
        <h3>Cancel All Posted Shifts?</h3>
        <p className="modal-subtitle">
          This action will remove all added shifts using the “Post Shifts” button.
          <br /> <br />
          Are you sure you want to continue?
        </p>
      </div>
      <div className="modal-footer">
        <button className="btn btn-outline" onClick={handleClose}>
          Cancel
        </button>
        <button
          className="btn btn-danger delete-line-btn"
          onClick={(e) => {
            e.stopPropagation();
            handleConfirm();
          }}
        >
          <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_14509_80520)">
              <path
                d="M19.6668 3.33136V8.33136M19.6668 8.33136H14.6668M19.6668 8.33136L15.8002 4.69803C14.9045 3.80196 13.7965 3.14737 12.5795 2.79534C11.3625 2.44331 10.0761 2.40532 8.8404 2.68491C7.60472 2.9645 6.46 3.55256 5.51305 4.39421C4.56611 5.23586 3.8478 6.30368 3.42516 7.49803M1.3335 16.6647V11.6647M1.3335 11.6647H6.3335M1.3335 11.6647L5.20016 15.298C6.09579 16.1941 7.20381 16.8487 8.42084 17.2007C9.63787 17.5527 10.9242 17.5907 12.1599 17.3111C13.3956 17.0316 14.5403 16.4435 15.4873 15.6018C16.4342 14.7602 17.1525 13.6924 17.5752 12.498"
                stroke="white"
                strokeWidth="1.67"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_14509_80520">
                <rect width="20" height="20" fill="white" transform="translate(0.5)" />
              </clipPath>
            </defs>
          </svg>
          Reset
        </button>
      </div>
    </Modal>
  );
};

export default CancelPostedShiftsModal;
